type NR = {
  setPageViewName?: (name: string) => void;
  setCustomAttribute?: (key: string, value: any) => void;
  setApplicationVersion?: (v: string) => void;
  addPageAction?: (name: string, attrs?: Record<string, any>) => void;
  noticeError?: (err: any, attrs?: Record<string, any>) => void;
  setCurrentRouteName?: (name: string) => void;
};

const globalNR = (window as any).newrelic as NR | undefined;

export const newrelic: NR = globalNR ?? {
  setPageViewName: () => undefined,
  setCustomAttribute: () => undefined,
  setApplicationVersion: () => undefined,
  addPageAction: () => undefined,
  noticeError: () => undefined,
  setCurrentRouteName: () => undefined,
};